import Image from '../../src/legacy/Image.tsx';
export default Image;
